import React, { useEffect, useState } from 'react';
// import { debounce } from 'lodash';
// import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import {  Warning, Calendar, Stats } from '../../assets/icons';
import '../../assets/css/pages/cases.css';
import { useNavigate } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import { casesApi } from '../../network/apis/cases';
import NewCaseModal from '../../components/aquadoc/newCase';
import { farmsApi } from '../../network/apis/farms';

const Dashboard = () => {
    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const [, setError] = useState(null);
    const [farms, setFarms] = useState([
        { id: '1', name: 'Ocean Harvest Farms', address: 'Coastal Bay, CA' },
        { id: '2', name: 'Blue Waters Aquaculture', address: 'Lake Region, OR' },
        { id: '3', name: 'Pacific Tides Fishing', address: 'Bay Harbor, WA' }
    ]);
    const [cases, setCases] = useState([
        // {
        //     id: 'CS001',
        //     title: 'Abnormal FishIcon Behavior',
        //     description: 'FishIcon showing erratic swimming patterns and loss of appetite',
        //     dateReported: '2024-03-15',
        //     status: 'pending',
        //     assignedTo: {
        //         type: 'doctor',
        //         name: 'Dr. Sarah Johnson'
        //     },
        //     labResults: 'Pending',
        //     priority: 'high',
        //     farm: 'Atlantic Aquaculture'
        // },
        // {
        //     id: 'CS002',
        //     title: 'FishIcon Mortality',
        //     description: 'High number of fish deaths reported in the past week',
        //     dateReported: '2024-03-10',
        //     status: 'open',
        //     assignedTo: {
        //         type: 'lab',
        //         name: 'Lab 1'
        //     },
        //     labResults: 'Positive for Vibrio',
        //     priority: 'medium',
        //     farm: 'Pacific Aquafarm'
        // },
        // {
        //     id: 'CS003',
        //     title: 'Unusual Algal Bloom',
        //     description: 'Greenish algae bloom observed in the fish pond',
        //     dateReported: '2024-03-05',
        //     status: 'resolved',
        //     assignedTo: {
        //         type: 'doctor',
        //         name: 'Dr. Alex Smith'
        //     },
        //     labResults: 'Negative for toxins',
        //     priority: 'low',
        //     farm: 'Oceanic Fishery'
        // },
        // {
        //     id: 'CS004',
        //     title: 'Water Quality Concerns',
        //     description: 'Abnormal pH levels detected in multiple tanks',
        //     dateReported: '2024-03-01',
        //     status: 'open',
        //     assignedTo: {
        //         type: 'lab',
        //         name: 'Lab 2'
        //     },
        //     labResults: 'Awaiting analysis',
        //     priority: 'high',
        //     farm: 'Deep Blue Aquaculture'
        // },
        // {
        //     id: 'CS005',
        //     title: 'Parasitic Infection',
        //     description: 'Signs of external parasites on juvenile fish',
        //     dateReported: '2024-02-28',
        //     status: 'pending',
        //     assignedTo: {
        //         type: 'doctor',
        //         name: 'Dr. Maria Rodriguez'
        //     },
        //     // labResults: 'Confirmed sea lice',
        //     labResults: 'Pending',
        //     priority: 'medium',
        //     farm: 'Coastal FishIcon Farm'
        // },
        // Add more cases...
    ]);
    // eslint-disable-next-line no-unused-vars
    const [, setLoading] = useState(true);

    // Sample data for the chart
    const chartData = {
        labels: ['Resolved', 'Pending', 'In Progress'],
        datasets: [
            {
                data: [300, 50, 100],
                backgroundColor: ['#4CAF50', '#FF9800', '#2196F3'],
                hoverBackgroundColor: ['#45a049', '#ff9800', '#2196f3'],
            //     backgroundColor: ['#ff6b6b', '#ffd93d', '#6bff84'],
            // borderWidth: 0
            },
        ],
    };

    const [showNewCaseForm, setShowNewCaseForm] = useState(false);

    
    const handleNewCase = () => {
        setShowNewCaseForm(true);
    };

    useEffect(() => {
        fetchCases();
        fetchFarms();
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    const fetchCases = async () => {
                try {
                    setLoading(true);
                    const response = await casesApi.getCases();
                
                // Handle paginated response
                if (response.data.data) {
                    setCases(response.data.data);
                } else {
                    setCases([]);
                }
            } catch (error) {
                setError(error.message || 'Failed to fetch cases');
                setCases([]);
            } finally {
                setLoading(false);
            }
            };

    const fetchFarms = async () => {
            try {
                setLoading(true);
                const response = await farmsApi.getFarms();
                if (response.data) {
                    setFarms(response.data);
                    console.log(response.data);
                } else {
                    setFarms([]);
                }
            } catch (error) {
                setError(error.message || 'Failed to fetch farms');
                setFarms([]);
            } finally {
                setLoading(false);
            }
        };

    const statsData = {
        total: cases.length,
        open: cases.filter(c => c.status.toLowerCase() === 'open').length,
        inProgress: cases.filter(c => c.status.toLowerCase() === 'pending').length,
        resolved: cases.filter(c => c.status.toLowerCase() === 'resolved').length,
        highPriority: cases.filter(c => c.priority.toLowerCase() === 'high').length
    };
    
     return (
            <div className="cases-page">
                <div className="cases-header">
                    <h1>Fish Farm Health Cases</h1>
                    <div className="header-actions">
                        <Button 
                            onClick={() => handleNewCase()}
                            text="Report New Case"
                            variant="primary"
                        />
                    </div>
                </div>
                {/* <div className="dashboard-section"> */}
                    <div className="stats-grid">
                        <div className="stat-card" onClick={()=> navigate('/cases')}>
                            <div className="stat-icon">
                                <img src={Stats} alt="Total Cases" />
                            </div>
                            <div className="stat-content">
                                <h4>Total Cases</h4>
                                <span className="stat-number">{statsData.total}</span>
                                <span className="stat-label">All time</span>
                            </div>
                        </div>
        
                        <div className="stat-card highlight">
                            <div className="stat-icon">
                                <img src={Warning} alt="High Priority" />
                            </div>
                            <div className="stat-content">
                                <h4>High Priority</h4>
                                <span className="stat-number">{statsData.highPriority}</span>
                                <span className="stat-label">Require immediate attention</span>
                            </div>
                        </div>
        
                        <div className="stat-card">
                            <div className="stat-icon">
                                <img src={Calendar} alt="Active Cases" />
                            </div>
                            <div className="stat-content">
                                <h4>Active Cases</h4>
                                <span className="stat-number">{statsData.open + statsData.inProgress}</span>
                                <span className="stat-label">Currently being handled</span>
                            </div>
                        </div>
                    </div>
    
                    <div className="summary-section">
                        <div className="summary-grid">
                            <div className="summary-table">
                                <h3>Case Summary</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Status</th>
                                            <th>Count</th>
                                            <th>Percentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="status-dot open"></span>
                                                Open
                                            </td>
                                            <td>{statsData.open}</td>
                                            <td>{Math.round((statsData.open / statsData.total) * 100)}%</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span className="status-dot pending"></span>
                                                In Progress
                                            </td>
                                            <td>{statsData.inProgress}</td>
                                            <td>{Math.round((statsData.inProgress / statsData.total) * 100)}%</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span className="status-dot resolved"></span>
                                                Resolved
                                            </td>
                                            <td>{statsData.resolved}</td>
                                            <td>{Math.round((statsData.resolved / statsData.total) * 100)}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
    
                            <div className="summary-chart">
                                <h3>Status Distribution</h3>
                                <div className="chart-container">
                                    <Doughnut 
                                        data={chartData}
                                        options={{
                                            cutout: '70%',
                                            responsive: true,
                                            maintainAspectRatio: true,
                                            plugins: {
                                                legend: {
                                                    position: 'bottom',
                                                    labels: {
                                                        boxWidth: 12,
                                                        padding: 15,
                                                        font: {
                                                            size: 12
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
    
                {/* </div> */}
                
    
                {showNewCaseForm && <NewCaseModal cases={cases} setCases={setCases} setShowNewCaseForm={setShowNewCaseForm} farms={farms} />}
            </div>
        );
    };

    export default Dashboard;